import React from "react";
import PropTypes from "prop-types";

export function Messaging({ messaging }) {
  const {
    enrolledPriorToFall2016,
    estimatedPaymentDisclaimer,
    inactiveLoanHistory,
  } = messaging;

  return (
    <>
      <Message message={enrolledPriorToFall2016} />
      <Message message={estimatedPaymentDisclaimer} />
      <Message message={inactiveLoanHistory} />
    </>
  );
}

Messaging.propTypes = {
  messaging: PropTypes.shape({
    enrolledPriorToFall2016: PropTypes.object,
    estimatedPaymentDisclaimer: PropTypes.object,
    inactiveLoanHistory: PropTypes.object,
  }),
};

function Message({ message: { title, description, code } = {} }) {
  if (title && description && code) {
    return (
      <div id={code}>
        {title && (
          <div className="message">
            <h3>{title}</h3>
            <p dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        )}
      </div>
    );
  }

  return null;
}

Message.propTypes = {
  message: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
  }),
};
